<template>
  <div id="Project">
    <div class="projectsContainer">
      <span v-for="(project, index) in projectLists" :key="index">
        {{ project.name }}
        <el-divider></el-divider>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projectLists: [
        { name: "广西重大专项，复杂环境下空天地一体协同重大灾害应急智慧服务平台研发与应用示范，2022-2025年（主持）" },
        { name: "横向项目，神农架国家公园生态调查研究与本底资源信息采集和数字化管理平台建设项目，2022-2025年（主持）" },
      //  { name: "十四五GF预研项目，XXXX方向典型应用，2022-2024年（主持）" },
      //  { name: "GF横向项目，GIS平台XXXX软件研制，2021-2022年（主持）" },
      //  { name: "GF预研项目，基于深度学习XXXX技术，2019-2021年（主持）" },
      //  { name: "GF预研项目，时空大数据XXXX技术，2019-2020年（主持）" },
      //  { name: "GF预研项目，敏感区域XXXX技术，2018-2020年（主持）" },
        { name: "国家重点研发计划，区域协同遥感监测与应急服务技术体系，2016-2020年（主持）" },
        { name: "国家自然科学基金，空地一体遥感震灾建筑物多级损毁自动判定研究，2018-2021年（主持）" },
      //  { name: "GF重大研制项目，SPD改进研制，2016-2018年（主持）" },
      //  { name: "GF重大型号项目，SPD采购项目，2016-2018年（主持）" },
        { name: "高分专项，XX灾害监测预评估与可视化技术研究及应用示范，2013-2015年（参加）" },
        { name: "国家主题863项目，统一时空体系下的多源信息实时接入与异构信息自主加载技术，2013-2015年（主持）" },
        { name: "国家973项目，高分辨率遥感影像的智能检索与在线服务，2012-2016年（参加）" },
        { name: "国家重点863项目，地理空间的三维建模与和分析软件及其应用示范，2008-2010年（主持）" },
        { name: "国家重点863项目，多源遥感数据处理与服务，2009-2010年（参加）" },
        { name: "国家自然科学基金，顾及多信息多特征的一体化三维变化检测方法，2006-2009年（主持）" },
        { name: "国家973项目，多源海量空间信息集成融合理论与实时动态更新，2006-2009 年（参加）" },
        { name: "国家973项目，流域水沙及环境变化特征信息监测反馈，2004-2007年（参加）" },
        { name: "国家863项目，基于遥感数据的航行情报应用技术，2006-2007年（参加）" },
        { name: "国家减灾委，环境与灾害监测预报小卫星星座减灾应用系统，2008-2010年（参加）" },
        { name: "国家减灾委，重大自然灾害应急监测与评估应用示范工程，2010-2011年（主持）" },
    //    { name: "广东海事局，海事信息资源整合理论研究，2008-2009年（主持）" },
    //   { name: "广东海事局，三维航标配布仿真演示系统，2007-2008年（主持）" },
    //  { name: "天津海事局，渤海航路扫测水深信息整理系统，2006-2007年（主持）" },
    //    { name: "国家测绘局海南基础地理信息中心，海南省防洪电子沙盘二期工程系统开发，2005-2006年（主持）" },
    //    { name: "其它多项国防型号与预研项目，以及多项横向项目。" },
      ]
    };
  },
};
</script>

<style lang='less' scoped>
#Project {
  margin-top: 20px;

  .projectsContainer {
    font-size: 14px;
    height: 600px;
    overflow-y: scroll;
  }

  .projectsContainer::-webkit-scrollbar {
    width: 6px;
  }

  .projectsContainer::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(208, 208, 208, 0.4);
  }
}
</style>
